import { DeleteOutlined } from '@mui/icons-material'
import { IconButton, MenuItem, Select, Stack } from '@mui/material'
import { useGridApiContext } from '@mui/x-data-grid-premium'
import isNil from 'lodash/isNil'
import { useMemo } from 'react'
import { RowGroupingModelCriteria, getRowGroupingModelCriteriaFromGridRowGroupingState } from '../helpers'

export function RowGroupingColumnSelect() {
  const { getAllColumns, setRowGroupingModel, state } = useGridApiContext().current

  const columns = getAllColumns()
  const rowGroupingColumns = columns.filter((column) => column.groupable).filter((column) => !isNil(column.headerName))
  const currentRowGroupingModelCriteria = useMemo(
    () => getRowGroupingModelCriteriaFromGridRowGroupingState(state.rowGrouping),
    [state.rowGrouping]
  )

  const handleRowGroupingModelCriteriaChange = (rowGroupingModelCriteria: RowGroupingModelCriteria) =>
    setRowGroupingModel(isNil(rowGroupingModelCriteria) ? [] : [rowGroupingModelCriteria])

  const handleSelect = (rowGroupingModelCriteria: RowGroupingModelCriteria) => {
    handleRowGroupingModelCriteriaChange(rowGroupingModelCriteria)
  }

  const resetRowGroupingModelCriteria = () => handleRowGroupingModelCriteriaChange(undefined)

  return (
    <Stack gap={1} flexDirection="row" sx={{ alignItems: 'center' }}>
      <Select
        sx={{
          maxHeight: 40,
          maxWidth: '268px',
          flexGrow: 1,
        }}
        value={currentRowGroupingModelCriteria ?? ''}
        onChange={(e) => handleSelect(e.target.value)}
      >
        {rowGroupingColumns?.map((rowGroupingColumn, i) => {
          return (
            <MenuItem key={i} sx={{ py: 2, px: 4 }} value={rowGroupingColumn.field}>
              {rowGroupingColumn.headerName}
            </MenuItem>
          )
        })}
      </Select>
      {!isNil(currentRowGroupingModelCriteria) && (
        <IconButton
          onClick={resetRowGroupingModelCriteria}
          sx={{
            borderRadius: '4px',
            borderWidth: '1px',
            borderStyle: 'solid',
            borderColor: 'border.subtle',
            m: 0,
            backgroundColor: 'bg.surface.subtle',
          }}
        >
          <DeleteOutlined />
        </IconButton>
      )}
    </Stack>
  )
}
